import type { GroupChannel } from "@/crossPlatform/Sendbird";
import useChatChannelContext from "@/hooks/useChatChannels";
import { isWeb } from "@/utils/platform.util";

const useWebSafeChatPatientId = (
  channel: GroupChannel | undefined,
): string | undefined => {
  const { selectedPatientId } = useChatChannelContext();
  if (!isWeb()) return selectedPatientId;
  if (selectedPatientId) return selectedPatientId;

  // on web, if you refresh while on a chat channel page (or navigate directly to it)
  // useChatChannelContext.selectedPatientId is unset (undefined)
  // which means clicking on file messages (that reference it) no-op/do not open the file preview modal
  const channelMetadata: ChannelMetadata | undefined = channel?.cachedMetaData;

  // so here we fallback to the patientId in the channel's metadata
  // an alternative would be to update useChatChannelContext.selectedPatientId
  // but this would re-render ChatChannelContextProvider, and all its children (ie, all tabs)
  return channelMetadata?.patientId;
};

export default useWebSafeChatPatientId;
